<template>
    <div class="auto-catalog-filter">
        <form method="post" action="/catalog/katalog_tovarov/" name="hlFilter" id="hlFilterForm">
            <nav aria-label="breadcrumb" role="navigation">
                <ol class="breadcrumb custom_params">
                  <li class="breadcrumb-item" aria-current="page"><a href="/">Главная</a></li>
                    <li  v-if="this.currentMark==''"   class="breadcrumb-item" aria-current="page">{{currentTypeName}}</li>
                    <li  v-if="this.currentMark"  class="breadcrumb-item" aria-current="page"><a  v-bind:href="'?type='+this.currentType">{{currentTypeName}}</a></li>

                    <li v-if="this.currentMark && this.currentModel" class="breadcrumb-item b_i_custom" aria-current="page"><a  v-bind:href="'?type='+this.currentType + '&mark='+ this.currentMark">{{currentMark}}</a></li>
                  <li v-if="this.currentMark && this.currentModel==''" class="breadcrumb-item b_i_custom" aria-current="page">{{currentMark}}</li>


                    <li v-if="this.currentModel && this.currentName" class="breadcrumb-item b_i_custom" aria-current="page"><a
                      v-bind:href="'?type='+this.currentType + '&mark='+ this.currentMark + '&model=' + this.currentModel"
                    >{{currentModel}}</a></li>
                    <li v-if="this.currentModel && this.currentName==''" class="breadcrumb-item b_i_custom" aria-current="page">{{currentModel}}</li>

                  <li v-if="this.currentName" class="breadcrumb-item b_i_custom" aria-current="page">{{currentName}}</li>


                </ol>
            </nav>
            <div class="row">



                <div class="col-12 mt-10">
                    <div class="row">
                        <div class="col-2 mt-3">
                            <label class="filter_hl_label">Тип</label>
                            <label v-if="this.currentType != ''" @click="clear_type()" class="filter_hl_remove_value">Отменить</label>
                            <el-select v-model="currentType" @change="hl_filter_apply()" placeholder="Не выбрано" name="hlFilter[type]">
                                <el-option v-for="item in typeList" :key="item.key" :label="item.name" :value="item.key"></el-option>
                            </el-select>
                        </div>
                        <div class="col-2 mt-3">
                            <label class="filter_hl_label">Марка</label>
                            <label v-if="this.currentMark != ''" @click="clear_mark()" class="filter_hl_remove_value">Отменить</label>
                            <el-select v-model="currentMark" @change="hl_filter_apply()" placeholder="Не выбрано" name="hlFilter[mark]"
                                       :disabled="!(currentType && markList.length > 0)">
                                <el-option v-for="(item, index) in markList" :key="index" :label="item" :value="item"></el-option>
                            </el-select>
                        </div>
                        <div class="col-2 mt-3">
                            <label class="filter_hl_label">Модель</label>
                            <label v-if="this.currentModel != ''" @click="clear_model()" class="filter_hl_remove_value">Отменить</label>
                            <el-select v-model="currentModel" @change="hl_filter_apply()" placeholder="Не выбрано" name="hlFilter[model]"
                                       :disabled="!(currentMark && markList.length > 0)">
                                <el-option v-for="(item, index) in modelList" :key="index" :label="item.UF_NAME" :value="item.UF_NAME"></el-option>
                            </el-select>
                        </div>
                        <div class="col-2 mt-3">
                            <label class="filter_hl_label">Наименование</label>
                            <label v-if="this.currentName != '' && !this.islat" @click="clear_name()" class="filter_hl_remove_value">Отменить</label>
                          <label v-if="this.islat"  style="color:red" class="filter_hl_remove_value error_ru">только русские буквы</label>
                            <el-autocomplete id="currentNameId" class="inline-input" style="width: 100%" v-model="currentName"
                                             name="hlFilter[name]"
                                             :fetch-suggestions="onNameInput"
                                             :disabled="!(currentModel && elementCount > 0)"
                                             @change="hl_change_name"
                                             @keyup="hl_change_name"
                                             @keypress="hl_change_name"
                                             @keyup.enter="hl_change_name"
                                             @input="hl_change_name"
                                             placeholder="Поиск по наименованию" :trigger-on-focus="true" @select="hl_filter_apply()"
                            ></el-autocomplete>
                        </div>
                      <div class="col-2 col-btn mt-3">
                        <button :disabled="elementCount === 0" type="button"     @click="hl_filter_apply()" name="hlFilter[find]" value="Y"
                                class=" btn btn-primary">Найти
                        </button>


                      </div>
                    </div>
                </div>




                <!--              <div class="col-2 mt-2 search_filter_section">
              <button type="button" @click="clear_filter()" name="hlFilter[clear]" value="Y" class="external-filter__find-button btn btn-primary">
                            Очистить
                        </button>
              </div>-->

            </div>
            <input type="hidden" v-for="(item,index) in modelList" :key="index" name="hlFilter[reference][]" :value="item.UF_XML_ID" />
            <input :value="referenceId" v-if="referenceId" type="hidden" name="hlFilter[reference]">

           <button type="button" @click="clear_filter()" name="hlFilter[clear]" value="Y" class="external-filter__clear-button">
                Сбросить
            </button>
        </form>
    </div>
</template>

<script>

  export default {
    name: 'hl-catalog-filter',
    props: {
      application: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data () {
      return {
        responseData: {},

        currentType: '',
        currentTypeName: '',
        currentMark: '',
        currentModel: '',
        currentName: '',
        islat: false,
        typeList: [],
        markList: [],
        modelList: [],
        referenceId: '',
        referenceLink: '',
        elementCount: 0,

        links: [],
        state1: '',
        state2: ''
      }
    },
    computed: {
      autoCatalogLink () {
        if (this.referenceLink === '') {
          return '/autocatalog/'
        } else {
          return '/autocatalog' + this.referenceLink
        }
      }
    },
    watch: {
      currentType (value) {
        this.currentMark = ''
        this.currentModel = ''

        if (value !== '') {
          let params = new FormData()
          params.append('type', value)
          this.referenceId = ''
          params.append('url', location.href)
          this.getData('getMarkList', params)
        }
      },
      currentMark (value) {
        this.currentModel = ''

        if (value !== '') {
          let params = new FormData()
          params.append('type', this.currentType)
          params.append('mark', value)
          this.referenceId = ''
          params.append('url', location.href)
          this.getData('getModelList', params)
        }
      },
      currentModel (value) {
        if (value !== '') {
          let params = new FormData()
          params.append('type', this.currentType)
          params.append('mark', this.currentMark)
          params.append('model', value)
          params.append('url', location.href)
          this.getData('getReferenceId', params)
        }
      }
    },
    methods: {

        clear_filter: function () {
            this.currentType = '';
          this.currentTypeName = '';
            this.currentMark = '';
            this.currentModel = '';
            this.currentName = '';
            this.islat = false;
            this.hl_filter_apply();
        },

        clear_type: function () {
            this.currentType = '';
          this.currentTypeName = '';
            this.currentMark = '';
            this.currentModel = '';
            this.currentName = '';
            this.hl_filter_apply();
        },

        clear_mark: function () {
            this.currentMark = '';
            this.currentModel = '';
            this.currentName = '';
            this.hl_filter_apply();
        },

        clear_model: function () {
            this.currentModel = '';
            this.currentName = '';
            this.hl_filter_apply();
        },
        clear_name: function () {
            this.currentName = '';
            this.hl_filter_apply();
        },
      hl_change_name(event){
          console.log("keyupa",'ok')
          if( /^[a-zA-Z0-9]+$/.test(this.currentName)){
            this.islat = true;
            this.currentName = this.currentName.replace(/[0-9a-zA-Z]/g,'')

          }else{
            this.islat = false;
          }
       // this.hl_filter_apply();
      },

        hl_filter_apply: function () {

            document.body.classList.remove('loaded');

            let url = '/catalog/';
            let result_url = String(window.location.href);

            let get_section_coe = String(window.location.href);
            let index_section_url_code = get_section_coe.indexOf('/');
            get_section_coe = get_section_coe.substr(0, 0) + get_section_coe.substr(0 + index_section_url_code);
            index_section_url_code = get_section_coe.indexOf('catalog');
            get_section_coe = get_section_coe.substr(0, 0) + get_section_coe.substr(0 + index_section_url_code);
            get_section_coe = get_section_coe.substr(0, 0) + get_section_coe.substr(0 + 8);
            index_section_url_code = get_section_coe.indexOf('/');
            get_section_coe = get_section_coe.slice(0, index_section_url_code);

            url += get_section_coe + '/'

            let index_param1 = result_url.indexOf('?type=');
            if(index_param1 != -1) {
                result_url = result_url.slice(index_param1, 6);
            }
            index_param1 = result_url.indexOf('&type=');
            if(index_param1 != -1) {
                result_url = result_url.slice(index_param1, 6);
            }
            index_param1 = result_url.indexOf('&mark=');
            if(index_param1 != -1) {
                result_url = result_url.slice(index_param1, 6);
            }
            index_param1 = result_url.indexOf('&model=');
            if(index_param1 != -1) {
                result_url = result_url.slice(index_param1, 7);
            }
            index_param1 = result_url.indexOf('&name=');
            if(index_param1 != -1) {
                result_url = result_url.slice(index_param1, 6);
            }

            if(this.currentType) {
                url += '?type=' + this.currentType
                if(this.currentMark) {
                    url += '&mark=' + this.currentMark;
                    if(this.currentModel) {
                        url += '&model=' + this.currentModel
                        if(this.currentName) {
                            url += '&name=' + this.currentName
                        }
                    }
                    url += '&section_code=' + get_section_coe
                }
            }

            url+= '&urla=' +result_url
          document.getElementsByClassName('spinner')[0].style.display = 'block';
            this.$http.get(url)
                .then(response => {

                    var wrapper= document.createElement('div');
                    wrapper.innerHTML= response.data;
                    var result_html_2 = wrapper.getElementsByClassName('js_for_factory_v2');
                    document.getElementById("js_from_factory_v2").innerHTML = result_html_2[0].outerHTML;
                    window.$('[data-toggle="popover"]').popover();

                    var subscrub_buttons =  document.getElementsByClassName('btn_hold');
                    Array.prototype.forEach.call(subscrub_buttons, function(el) {
                        var re = /'/gi;
                        var str = el.getAttribute('data-param_for_js');
                       if(typeof str==='undefined')  return {};
                        try{
                          var newstr = str.replace(re, '"');
                          window[el.getAttribute('data_js_object')] = new JCCatalogProductSubscribe(JSON.parse(newstr));
                        }catch (e) {

                        }

                    });


                    if(result_url.indexOf('/?') != -1) {
                        if(this.currentType) {
                            result_url += '&type=' + this.currentType
                        }
                    } else {
                        if(this.currentType) {
                            result_url += '?type=' + this.currentType
                        }
                    }
                    if(this.currentMark) {
                        result_url += '&mark=' + this.currentMark;
                    }
                    if(this.currentModel) {
                        result_url += '&model=' + this.currentModel
                        if(this.currentName) {
                            result_url += '&name=' + this.currentName
                        }
                    }

                    if(!result_url) {
                        result_url = window.location.pathname;
                    }

                    history.pushState(null, null, result_url)


                  document.body.classList.add('loaded_hiding');
                    window.setTimeout(function () {
                        document.body.classList.add('loaded');
                        document.body.classList.remove('loaded_hiding');
                    }, 500);
                  document.getElementsByClassName('spinner')[0].style.display = 'none';
                })
            while (document.getElementsByClassName('bs-popover-bottom')[0]) {
                document.getElementsByClassName('bs-popover-bottom')[0].remove();
            }
            while (document.getElementsByClassName('bs-popover-top')[0]) {
                document.getElementsByClassName('bs-popover-top')[0].remove();
            }



          for (let k in this.typeList){
                     if(this.currentType == this.typeList[k].key){
                      // this.currentType = this.application.saved.type
                       this.currentTypeName = this.typeList[k].name;
                     }
                   }


            // elements_rem = document.getElementsByClassName("bs-popover-bottom");
            // while (elements_rem.length > 0) {
            //     elements_rem[0].remove();
            // }
            // elements_rem = document.getElementsByClassName("bs-popover-top");
            // while (elements_rem.length > 0) {
            //     elements_rem[0].remove();
            // }
        },

      getData (action = '', params) {
        let vm = this
        vm.elementCount = 0
        vm.responseData = { };
        this.$http.post('/ajax_new/ModelFilter/' + action, params)
          .then(response => {
            let data = { };
            if(!!response.data.data)
              data =   response.data.data;

            vm.responseData = data;
            if (typeof data.typeList!=='undefined' &&  Array.isArray(data.typeList)) {
              vm.typeList = data.typeList
              if (this.currentType === '' && this.application.saved && this.application.saved.type) {
                this.currentType = this.application.saved.type
                console.log(this.application.saved.type, 'this.application.saved.type');
                for (let k in vm.typeList){
                  if(this.application.saved.type == vm.typeList[k].key){
                   //
                    this.currentTypeName = vm.typeList[k].name;
                  }
                }

              }
            }
            if (Array.isArray(data.markList)) {
              vm.markList = data.markList
              if (this.currentMark === '' && this.application.saved && this.application.saved.mark && this.currentType === this.application.saved.type) {
                this.currentMark = this.application.saved.mark
              }
            }
            if (Array.isArray(data.modelList)) {
              vm.modelList = data.modelList
              if (this.currentModel === '' && this.application.saved && this.application.saved.model && this.currentMark === this.application.saved.mark) {
                this.currentModel = this.application.saved.model
              }
            }
            if (data.reference && data.reference !== '') {
              vm.referenceId = data.reference
              vm.referenceLink = data.link.replace('http://', '').replace('https://', '').replace('acat.online/catalogs', '').replace('acat.online', '')
            }
            if (data.count !== undefined) {
              vm.elementCount = + data.count ? data.count : 0
            }
          })
      },
      getListFromData (dataList, mapFunction) {
        if (!Array.isArray(dataList) || dataList.length === 0) {
          return []
        }
        return dataList.map(mapFunction)
      },
      onNameInput (query, callbackF) {
        this.getNameList(query)
          .then(response => {
            if (Array.isArray(response.data.data.nameList)) {
              callbackF(response.data.data.nameList.map(item => {
                return {
                  value: item.name,
                  article: item.article
                }
              }))
            } else {
              callbackF([])
            }
          })
          .catch(() => {
            callbackF([])
          })
      },
      getNameList (query) {
        let params = new FormData()
        params.append('name', query)
        params.append('reference', this.referenceId)
        return this.$http.post('/ajax_new/ModelFilter/getNameList', params)
      }
    },
    mounted () {

    document.getElementsByClassName("main-breadcrumb")[0].style.display='none';
      //document.getElementById()
 /*     $("#currentNameId").on('keyup change',function(){
        $(this).val('sdg');
      });*/
      let params = new FormData()
      params.append('url', location.href)
      this.getData('getTypeList', params)
      if (this.currentName === '' && this.application.saved && this.application.saved.name && this.application.saved.name !== '') {
        this.currentName = this.application.saved.name
      }
    }
  }
</script>

<style>
    .el-select {
        display: inline-block;
        position: relative;
        width: 100%;
    }
    #hlFilterForm {
        position: relative;
    }
    .external-filter__clear-button {
        position: absolute;
        top: 0;
        right: 0;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #444444;
    }
    .filter_hl_label {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: #333333;
    }
    .search_filter_section {
        padding-top: 31px;
    }
    .search_filter_section .external-filter__find-button {
        height: 40px;
        width: 100%;
        background: #D81422 !important;
        text-transform: none !important;
    }
    .filter_hl_remove_value {
        font-size: 12px;
        float: right;
        display: block;
        cursor: pointer;
        font-weight: 100;
        opacity: 0.7;
        margin-bottom: 0px;
        line-height: 24px;
    }
    .main-breadcrumb{
     /* display: none;*/
    }
</style>



// WEBPACK FOOTER //
// src/vue/components/hlCatalogFilter/HlCatalogFilter.vue